import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    return localStorage.getItem('theme') || 'system';
  });

  const getEffectiveTheme = (t) => {
    if (t === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return t;
  };

  const applyTheme = (t) => {
    const effective = getEffectiveTheme(t);
    document.documentElement.classList.toggle('dark', effective === 'dark');
  };

  useEffect(() => {
    applyTheme(theme);

    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = () => applyTheme('system');
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
  }, [theme]);

  const setTheme = async (newTheme) => {
    setThemeState(newTheme);
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);

    try {
      await api.put('/auth/preferencias', { tema: newTheme });
    } catch {}
  };

  const loadUserTheme = async () => {
    try {
      const res = await api.get('/auth/preferencias');
      if (res.data?.tema) {
        setThemeState(res.data.tema);
        localStorage.setItem('theme', res.data.tema);
        applyTheme(res.data.tema);
      }
    } catch {}
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, loadUserTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
